import type { SectionPreviewProps } from "@op/puck-types";
import { Print_Dc_Card_Hash } from "@op/sf-op";
import {
  makeEditorImageUrl,
  makeRendererImageUrl,
  MediaPreview,
  useRender,
} from "@op/utils";
import { useMemo } from "react";

function getLinkType(
  href?: string
): "internal" | "external" | "hash" | "excursion" {
  if (href?.startsWith("#")) {
    return "hash";
  } else if (href?.startsWith("/")) {
    return "internal";
  } else if (href?.startsWith("http")) {
    return "external";
  } else if (href?.startsWith("exc")) {
    return "excursion";
  } else {
    return "external";
  }
}

const SectionPreview = ({
  children,
  medium,
  headline,
  button,
}: SectionPreviewProps) => {
  const linkType = getLinkType(button?.href);
  const linkTarget = linkType === "external" ? "_blank" : undefined;

  const { context, apiUrl } = useRender();

  const imageUrl = useMemo(() => {
    if (!medium || !medium.uploadId) return "";
    switch (context) {
      case "editor":
        return makeEditorImageUrl(medium.uploadId, apiUrl);
      case "renderer":
        return makeRendererImageUrl(medium.uploadId, apiUrl);
      default:
        return "";
    }
  }, [context, apiUrl, medium]);

  return (
    <Print_Dc_Card_Hash
      style={{
        breakInside: "avoid-page",
      }}
      headline={headline}
      imageSlot={
        medium && (
          <MediaPreview
            cover
            src={imageUrl}
            alt={medium.metadata?.caption || ""}
            mimeType={medium.mimeType}
            width={medium.width}
            height={medium.height}
            loading="eager"
            autoPlay={false}
          />
        )
      }
      buttonSlot={
        button?.href && (
          <a href={button.href} target={linkTarget}>
            <Print_Dc_Card_Hash.JumpLink>
              {button.text}
            </Print_Dc_Card_Hash.JumpLink>
          </a>
        )
      }
      text={children as string}
    />
  );
};

export default SectionPreview;
